"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const invariant_1 = __importDefault(require("invariant"));
const getAccountNetworkInfo_1 = require("./getAccountNetworkInfo");
const logic_1 = require("./logic");
const prepareTransaction = (a, t) => __awaiter(void 0, void 0, void 0, function* () {
    let networkInfo = t.networkInfo;
    if (!networkInfo) {
        networkInfo = yield (0, getAccountNetworkInfo_1.getAccountNetworkInfo)(a);
        (0, invariant_1.default)(networkInfo.family === "bitcoin", "bitcoin networkInfo expected");
    }
    const feePerByte = (0, logic_1.inferFeePerByte)(t, networkInfo);
    if ((t.networkInfo === networkInfo &&
        (feePerByte === t.feePerByte || feePerByte.eq(t.feePerByte || 0))) ||
        t.feesStrategy === "custom") {
        // nothing changed
        return t;
    }
    return Object.assign(Object.assign({}, t), { networkInfo,
        feePerByte });
});
exports.default = prepareTransaction;
//# sourceMappingURL=js-prepareTransaction.js.map